import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { PermissionService } from 'src/app/utils/permission.service';
import { InitDisplayedCol, Page, PageCtrl } from '../../models/common';

@Component({
  selector: 'app-table4-ui',
  templateUrl: './table4-ui.component.html',
  styleUrls: ['./table4-ui.component.css'],
})
export class Table4UiComponent implements OnInit {
  @ViewChild('table') table: MatTable<any>;
  @ViewChild(MatSort) sort: MatSort;
  @Input() set data(payload: any) {
    let data = payload;
    if (payload) {
      data = this.preCheckSelectedIds(payload);
    }
    this.dataSource = new MatTableDataSource(
      Array.isArray(payload) ? payload : null
    );
  }
  @Input() initColumns: InitDisplayedCol[];
  @Input() selectedIds: Set<number> = new Set();
  @Input() pageProp: Page;
  @Input() showPagination: boolean;

  @Input() usePermission: boolean = false;

  @Input() matSortActive: string = '';
  @Input() matSortDirection: SortDirection = '';
  @Input() showCheckboxes: boolean = true;

  @Output() checkboxCheckEmit: EventEmitter<any> = new EventEmitter();
  @Output() pageSizeToggle: EventEmitter<number> = new EventEmitter();
  @Output() PageCtrlToggle: EventEmitter<PageCtrl> = new EventEmitter();
  @Output() sortEmit: EventEmitter<any> = new EventEmitter();
  @Output() rowClick: EventEmitter<any> = new EventEmitter();
  collapsedColumnKeys: string[] = [];
  public headers: {
    value: string;
    count: number;
    colDef: string;
    colDefIndex?: number;
  }[] = [];

  public displayedColumns: string[];
  public dataSource: MatTableDataSource<any>;
  public masterCheckboxChecked: boolean;
  // public headers = [];
  public headersCol = [];

  minDate: Date;
  maxDate: Date;

  constructor(private permissionsService: PermissionService) {
    const currentYear = new Date().getFullYear();
    const currentTime = new Date();
    this.minDate = new Date(currentYear - 6, 0, 1);
    this.maxDate = new Date(currentTime);
  }

  toggleHeaderCollapse(header: {
    colDef: string;
    value: string;
    count: number;
    colDefIndex?: number;
  }) {
    const columnsInGroup = this.initColumns
      .slice(header.colDefIndex, header.colDefIndex + header.count)
      .map((c) => c.key);

    const allHidden = columnsInGroup.every((col) =>
      this.collapsedColumnKeys.includes(col)
    );

    if (allHidden) {
      // Show all columns in group
      this.collapsedColumnKeys = this.collapsedColumnKeys.filter(
        (col) => !columnsInGroup.includes(col)
      );
    } else {
      // Hide all columns in group
      this.collapsedColumnKeys = [
        ...this.collapsedColumnKeys,
        ...columnsInGroup,
      ];
    }

    this.updateDisplayedColumns();
  }

  isHeaderCollapsed(header: any): boolean {
    const columnsInGroup = this.initColumns
      .slice(header.colDefIndex, header.colDefIndex + header.count)
      .map((c) => c.key);
    return columnsInGroup.every((col) =>
      this.collapsedColumnKeys.includes(col)
    );
  }

  updateDisplayedColumns() {
    this.displayedColumns = this.initColumns
      .filter((col) => !this.collapsedColumnKeys.includes(col.key))
      .map((col) => col.key);
  }
  private checkAndSetHeaders() {
    this.headers = [];

    let index = 0;
    while (index < this.initColumns.length) {
      const current = this.initColumns[index];
      const headerLabel = current.header || '';
      let count = 1;

      // Count how many times this header repeats consecutively
      for (
        let j = index + 1;
        j < this.initColumns.length &&
        this.initColumns[j].header === current.header;
        j++
      ) {
        count++;
      }

      this.headers.push({
        value: headerLabel,
        count: count,
        colDef: headerLabel || Math.random().toString(36).slice(2, 7),
        colDefIndex: index, // 💡 now you can slice based on index
      });

      index += count;
    }

    this.headersCol = this.headers.map((col) => col.colDef);
  }

  ngOnInit(): void {
    this.checkAndSetHeaders();
    this.displayedColumns = this.initColumns.map((col) => col.key);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.checkAndSetHeaders();
    this.displayedColumns = this.initColumns.map((col) => col.key);
    if (!this.selectedIds.size) {
      this.masterCheckboxChecked = false;
    }
    // if(changes['pageProp']) this.pageProp = changes['pageProp'].currentValue
  }

  ngAfterViewInit() {
    if (this.dataSource) this.dataSource.sort = this.sort;
  }

  private preCheckSelectedIds(data: any[]) {
    if (!data || !data.length) return;
    return data.map((d) => {
      d.checked = this.selectedIds.has(d.id);
      return d;
    });
  }

  public hasPermission(perms: string[]) {
    return this.permissionsService.hasPermissionList(perms);
  }
  public showToolTip(val, maxLen) {
    const len = maxLen ?? 50;
    if (val.length <= len) {
      return val;
    }
    return '';
  }

  public announceSortChange(sortState: any) {
    this.sortEmit.emit(sortState);
  }

  public onPageSizeToggle(val: number) {
    this.pageSizeToggle.emit(val);
  }
  public onPageCtrlToggle(val: PageCtrl) {
    this.PageCtrlToggle.emit(val);
  }

  public onCheck(event: MatCheckboxChange, item: any) {
    if (this.masterCheckboxChecked) this.masterCheckboxChecked = false;
    const elemCount = this.dataSource.data.length;
    this.dataSource.data.map((d: any) => {
      if (d.id) {
        if (d.id === item.id) d.checked = event.checked;
        if (d.checked) {
          this.selectedIds.add(d.id);
        } else {
          this.selectedIds.delete(d.id);
        }

        return;
      }

      if (d.accountId) {
        if (d.accountId === item.accountId) d.checked = event.checked;
        if (d.checked) {
          this.selectedIds.add(d.accountId);
        } else {
          this.selectedIds.delete(d.accountId);
        }
        return;
      }
    });
    if (this.selectedIds.size === elemCount) this.masterCheckboxChecked = true;
    this.checkboxCheckEmit.emit(this.selectedIds);
  }

  public onCheckAll(event: MatCheckboxChange) {
    this.masterCheckboxChecked = event.checked;
    this.dataSource.data.forEach((element: any) => {
      element.checked = event.checked;
    });
    this.selectedIds = new Set(
      this.dataSource.data.map((val) => val.id || val.accountId)
    );
    event.checked
      ? this.checkboxCheckEmit.emit(this.selectedIds)
      : this.checkboxCheckEmit.emit(new Set());
  }

  public unCheckAll() {
    this.masterCheckboxChecked = false;
    this.data.forEach((element: any) => {
      element.checked = false;
    });
  }

  public triggerRowClick(rowId: number) {
    this.rowClick.emit(rowId);
  }
}
